import { getLanguageLocale } from "@/common/helpers/get-language-locale";
import { userConfigStore } from "@/store/user-config-store";

enum IsoType {
  Region = "region",
  Language = "language",
}

const convertIsoToReadableName = (code: string | null | undefined, type: IsoType): string | undefined => {
  const trimmed = code?.trim();

  if (!trimmed) {
    return undefined;
  }

  const locale = getLanguageLocale(userConfigStore.getState().language);
  const normalizedCode = type === IsoType.Region ? trimmed.toUpperCase() : trimmed.toLowerCase();

  try {
    return new Intl.DisplayNames([locale], { type: type }).of(normalizedCode) ?? trimmed;
  } catch {
    return trimmed;
  }
};

export const isoToCountryName = (countryCode: string | null | undefined): string | undefined => {
  return convertIsoToReadableName(countryCode, IsoType.Region);
};

export const isoToLanguageName = (languageCode: string | null | undefined): string | undefined => {
  return convertIsoToReadableName(languageCode, IsoType.Language);
};
